// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取因子列表 GET /stock-score/factor/list */
export async function stockScoreFactorListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockScoreFactorListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockFactorResp>('/stock-score/factor/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 竞价算力股票得分列表 POST /stock-score/score-list */
export async function stockScoreScoreListUsingPOST(
  body: API.StockScoreListReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStockScoreInfoResp>('/stock-score/score-list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 竞价算力股票详情 POST /stock-score/stock-info */
export async function stockScoreStockInfoUsingPOST(
  body: API.StockScoreInfoReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockScoreResp>('/stock-score/stock-info', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 竞价算力股票列表 POST /stock-score/stock-list */
export async function stockScoreStockListUsingPOST(
  body: API.StockScoreReq,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockScoreResp>('/stock-score/stock-list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
